import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "bg_white table_90 m-t-10 border-r-10 text-black f-12"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  key: 3
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: _ctx.serachCom
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("搜索")])),
          _: 1,
          __: [7]
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: _ctx.resetSearch
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("重置")])),
          _: 1,
          __: [8]
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: _ctx.synchronizeErp
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("批量重传")])),
          _: 1,
          __: [9]
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_vxe_table, {
      class: "mytable-style m-t-10",
      border: "",
      onCheckboxChange: _ctx.getSelectRow,
      onCheckboxAll: _ctx.getSelectRow,
      "header-row-style": _ctx.data.header_style,
      resizable: "",
      "show-overflow": "",
      ref: "xTable",
      height: "700",
      "auto-resize": "",
      data: _ctx.data.tableData,
      "edit-config": _ctx.data.editConfig
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_column, {
        type: "checkbox",
        width: "40"
      }), _createVNode(_component_vxe_colgroup, {
        title: "同步类别",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "type",
          width: "180"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _ctx.data.form_requst.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.form_requst.type = $event),
            class: "m-2",
            placeholder: "请选择",
            size: "mini"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.syncType, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                value: item.id,
                label: item.value
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "规格型号（sku）",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "sku",
          width: "280"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_input, {
            size: "mini",
            modelValue: _ctx.data.form_requst.sku,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.data.form_requst.sku = $event),
            placeholder: "暂无结果",
            onKeydown: _withKeys(_ctx.searchList, ["enter", "native"])
          }, null, 8, ["modelValue", "onKeydown"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "名称",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "name",
          width: "200"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_input, {
            size: "mini",
            modelValue: _ctx.data.form_requst.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.data.form_requst.name = $event),
            placeholder: "暂无结果",
            onKeydown: _withKeys(_ctx.searchList, ["enter", "native"])
          }, null, 8, ["modelValue", "onKeydown"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "同步对象",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "platform",
          width: "180",
          align: "center"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _ctx.data.form_requst.platform,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.data.form_requst.platform = $event),
            class: "m-2",
            placeholder: "请选择",
            size: "mini"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.syncObject, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                value: item.id,
                label: item.value
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          default: _withCtx(({
            row
          }) => [row.platform == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[10] || (_cache[10] = [_createElementVNode("span", null, _toDisplayString('全部'), -1)]))) : _createCommentVNode("", true), row.platform == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[11] || (_cache[11] = [_createElementVNode("span", null, _toDisplayString('金蝶'), -1)]))) : _createCommentVNode("", true), row.platform == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[12] || (_cache[12] = [_createElementVNode("span", null, _toDisplayString('聚水潭'), -1)]))) : _createCommentVNode("", true), row.platform == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[13] || (_cache[13] = [_createElementVNode("span", null, _toDisplayString('领星'), -1)]))) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "同步状态",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "status",
          width: "150",
          align: "center"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _ctx.data.form_requst.status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.data.form_requst.status = $event),
            class: "m-2",
            placeholder: "请选择",
            size: "mini"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.syncStatus, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                value: item.id,
                label: item.value
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          default: _withCtx(({
            row
          }) => [row.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[14] || (_cache[14] = _createElementVNode("span", {
            style: {
              color: '#D9001B',
              fontSize: '12px'
            }
          }, _toDisplayString('失败'), -1)), _createElementVNode("span", {
            onClick: $event => _ctx.signClick(row),
            style: {
              color: '#137AE9',
              marginLeft: '10px',
              cursor: 'pointer',
              fontSize: '12px'
            }
          }, _toDisplayString('重传'), 8, _hoisted_7)])) : _createCommentVNode("", true), row.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[15] || (_cache[15] = [_createElementVNode("span", null, _toDisplayString('成功'), -1)]))) : _createCommentVNode("", true), row.status == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[16] || (_cache[16] = [_createElementVNode("span", null, _toDisplayString('同步中,请稍后刷新'), -1)]))) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        title: "同步详情",
        field: "msg",
        "header-align": "center",
        width: "230",
        resizable: ""
      }), _createVNode(_component_vxe_colgroup, {
        title: "同步人",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "admin_name",
          width: "180"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_input, {
            size: "mini",
            modelValue: _ctx.data.form_requst.admin_name,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.data.form_requst.admin_name = $event),
            placeholder: "暂无结果",
            onKeydown: _withKeys(_ctx.searchList, ["enter", "native"])
          }, null, 8, ["modelValue", "onKeydown"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "同步时间",
        "header-align": "center",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "async_time",
          width: "268"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: _ctx.data.form_requst.async_time,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.data.form_requst.async_time = $event),
            type: "daterange",
            "unlink-panels": "",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            "range-separator": "-",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["onCheckboxChange", "onCheckboxAll", "header-row-style", "data", "edit-config"]), _createVNode(_component_el_pagination, {
      "current-page": _ctx.data.form_requst.page,
      "page-sizes": [100, 200, 300],
      "page-size": _ctx.data.form_requst.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: _ctx.data.form_requst.count,
      class: "m-t-10 m-b-20 table_90",
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange
    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])]),
    _: 1
  });
}